module.exports = __webpack_public_path__ + "img/j6.9ee0b60e.png";